import { Link, Navigate } from 'react-router-dom';
import PathPresenterImport from '../../components/pathpresenter/PathPresenterImport';
import {
    DATA_MANAGER_HOME,
    DATA_MANAGER_WORKSPACE_LABEL,
    getVisibleDataManagerStep,
} from '../../constants/setupRoadmapSteps';
import { isPdsaMode } from '../../utils/appBranding';
import styles from './PathPresenterImportPage.module.css';

/**
 * Data Manager page for importing PathPresenter public shares.
 */
export default function PathPresenterImportPage() {
    if (!isPdsaMode()) {
        return <Navigate to={DATA_MANAGER_HOME} replace />;
    }

    const importStep = getVisibleDataManagerStep('import');

    return (
        <div className={styles.page}>
            <p className={styles.crumb}>
                <Link to={DATA_MANAGER_HOME}>{DATA_MANAGER_WORKSPACE_LABEL}</Link>
                {importStep ? (
                    <>
                        {' · '}
                        Step {importStep.number} of {importStep.total}
                    </>
                ) : null}
            </p>
            <PathPresenterImport className={styles.widget} />
        </div>
    );
}
